/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import _ from 'lodash';

import { ArrowBack } from '@material-ui/icons';
import { formatDate } from './commentsAndNotes.component';
import { ExceptionId } from '../notesAndCommunicationEditableCard.component';
import {
  deleteAuthCommentsAttachment,
  deleteAuthorizationComment,
  getAuthorizationComments,
  postAuthCommentsAttachment,
  postAuthorizationComment,
  updateAuthCommentsAttachment,
  updateAuthorizationComment
} from 'modules/authorizations/store/actions/authorizations.actions';
import { ExceptionStatusOptions } from './commentAndNotesConstants';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';
import {
  DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  DELETE_AUTHORIZATION_COMMENTS_FAILURE,
  POST_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  POST_AUTHORIZATION_COMMENTS_FAILURE,
  UPDATE_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  UPDATE_AUTHORIZATION_COMMENTS_FAILURE
} from 'modules/authorizations/store/types/authorizationTypes';
import { EmailEditorQuill } from 'modules/emailTemplates/emailEditors/EmailEditorQuill';
import AttachmentsUpload from 'modules/common/attachments/attachmentsUpload.component';
import ConfirmationDialog from 'modules/common/confirmationDialog.component';
import SpinnerComponent from 'modules/common/spinner.component';
import Hint from 'modules/common/hint.component';
import ExceptionCommentComponent from './exceptionComment.component';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { getExceptionsByAuthorizationId, getExceptionsByClientId } from 'modules/expenses/store/expenses.actions';
import {
  getAuthCommentRegardingOptions,
  getAuthCommentServiceOptions,
  isIdEqual
} from 'modules/enumerations/enumerationHelpers';

const FALLBACK_PENDING_EXCEPTION_STATUS_ID = ExceptionStatusOptions.find(status => status.title === 'Pending')?.id;

const SelectedCommentAndNote = props => {
  const {
    selectedComment,
    isUnsavedComment = false,
    onUnsavedCommentResolved,
    onUnsavedCommentDeleted,
    commentsAndNotesWithAttachments,
    setIsLoading,
    isNewComment,
    setSelectedComment,
    halfView,
    enumerations,
    authorizationId,
    defaultEmail,
    clientContacts,
    onAfterCreate,
    isAuthLineItem,
    clientId,
    setExceptionState,
    expenseCodes,
    registerLeaveGuard,
    isReadOnly = false
  } = props;

  const enums = enumerations?.allEnums || enumerations || [];
  const PENDING_EXCEPTION_STATUS_ID =
    enums?.exceptionStatuses?.find(status => status.title === 'Pending')?.id || FALLBACK_PENDING_EXCEPTION_STATUS_ID;
  const internalUserTypes =
    props.internalUserTypesEnum && props.internalUserTypesEnum.length > 0
      ? props.internalUserTypesEnum.filter(s => s.isActive === true)
      : [];

  const internalUsersMapping = [];
  if (props.internalUsers) {
    props.internalUsers.map((iu) => {
      const internalUserType = internalUserTypes.find((iut) => iut.id === iu.internalUserTypeId)?.title;
      internalUsersMapping.push({
        title: `${iu.firstName} ${iu.lastName} (${internalUserType})`,
        id: iu.internalUserId
      })
    })
  }
  const canSubmitExceptions = hasPermission(Permissions.File.Exceptions.Submit);

  const commentCreatedParties = enums?.commentCreatedParties || [];

  const [isCancelButtonDisabled, setIsCancelButtonDisabled] = useState(true);
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [lockScreen, setLockScreen] = useState(selectedComment || isNewComment ? false : true);
  const [commentFormData, setCommentFormData] = useState(selectedComment);
  const history = useHistory();
  const savedDraft = useRef(null);
  const unblockNavigation = useRef(null);
  const [pendingLeave, setPendingLeave] = useState(null);
  const [isSavingBeforeLeave, setIsSavingBeforeLeave] = useState(false);
  const [isSendToClientConfirmOpen, setIsSendToClientConfirmOpen] = useState(false);
  const hasUnsavedChanges = !isReadOnly && Boolean(selectedComment || isNewComment) &&
    !_.isEqual(commentFormData || {}, savedDraft.current || selectedComment || {});

  const requestLeave = action => {
    if (isSavingBeforeLeave) return;
    if (hasUnsavedChanges) setPendingLeave({ action });
    else action();
  };

  useEffect(() => {
    if (!registerLeaveGuard) return;
    return registerLeaveGuard(requestLeave);
  }, [registerLeaveGuard, hasUnsavedChanges, isSavingBeforeLeave]);

  useEffect(() => {
    if (!hasUnsavedChanges) return;
    const unblock = history.block((nextLocation, action) => {
      setPendingLeave({
        action: () => {
          unblock();
          if (action === 'PUSH') history.push(nextLocation);
          else history.replace(nextLocation);
        }
      });
      return false;
    });
    unblockNavigation.current = unblock;
    const warnBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => {
      unblock();
      unblockNavigation.current = null;
      window.removeEventListener('beforeunload', warnBeforeUnload);
    };
  }, [hasUnsavedChanges, history]);
  const [showExpenseForm, setShowExpenseForm] = useState(commentFormData?.isException === true);

  const serviceOptions = useMemo(() => getAuthCommentServiceOptions(enums?.authCommentService), [enums?.authCommentService]);
  // Derived from the form's service, so selecting, editing, cancelling and saving all keep the list in step
  const filteredRegardingOptions = useMemo(
    () => getAuthCommentRegardingOptions(enums?.authCommentRegarding, commentFormData?.serviceId),
    [enums?.authCommentRegarding, commentFormData?.serviceId],
  );

  const isEmailTemplate = !!(selectedComment && selectedComment.templateId && selectedComment.templateId > 0);
  const isRichTextEditorEnabled = false;
  const [isRichTextMode, setIsRichTextMode] = useState(isEmailTemplate);

  const [isUploading, setIsUploading] = useState(false);

  const [openDocumentShareDialog, setOpenDocumentShareDialog] = useState(false);
  const [selectedFileForDocumentShare, setSelectedFileForDocumentShare] = useState(null);
  const [wasAlreadyNotified, setWasAlreadyNotified] = useState(false);

  const [isExceptionSentToClient, setIsExceptionSentToClient] = useState((selectedComment?.isClientViewable && selectedComment?.isException) || false);

  const checkRequiredValues = () => {
    if (
      commentFormData &&
      commentFormData?.regardingId &&
      commentFormData?.serviceId &&
      commentFormData?.subject &&
      commentFormData?.subject !== '' &&
      commentFormData?.comment &&
      commentFormData?.comment !== ''
    ) {
      if (commentFormData?.regardingId !== ExceptionId) {
        return true;
      }
      if (
        commentFormData?.exceptionReason &&
        commentFormData?.exceptionReason !== '' &&
        // commentFormData?.requestedAmount &&
        // commentFormData?.requestedAmount > 0 &&
        commentFormData?.statusId &&
        commentFormData?.statusId !== '' &&
        commentFormData?.categoryId &&
        commentFormData?.categoryId !== '' &&
        commentFormData?.expenseCodeId &&
        commentFormData?.expenseCodeId !== '' &&
        commentFormData?.requestTypeId &&
        commentFormData?.requestTypeId !== ''
      ) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (isFormDirty()) {
      setIsCancelButtonDisabled(false);

      if (checkRequiredValues()) {
        setIsSubmitDisable(false);
      } else if (commentFormData?.statusId === 'Pending') {
        setIsSubmitDisable(true);
      } else {
        setIsSubmitDisable(true);
      }
    } else {
      if (isNewComment && checkRequiredValues()) {
        setIsSubmitDisable(false);
      } else {
        setIsSubmitDisable(true);
      }
      if (halfView && isNewComment) {
        setIsCancelButtonDisabled(false);
      } else {
        setIsCancelButtonDisabled(true);
      }
    }
  }, [commentFormData, selectedComment, isNewComment]);

  useEffect(() => {
    savedDraft.current = null;
    setCommentFormData({ ...selectedComment });
    setIsExceptionSentToClient(Boolean(selectedComment?.isClientViewable && selectedComment?.isException));
    if (selectedComment || isNewComment) {
      setLockScreen(false);
    } else {
      setLockScreen(true);
    }
    const isTemplate = !!(selectedComment && selectedComment.templateId && selectedComment.templateId > 0);
    setIsRichTextMode(isTemplate);
  }, [selectedComment, isNewComment]);

  useEffect(() => {
    if (commentFormData?.isException === true) {
      setShowExpenseForm(true);
      setCommentFormData({ ...commentFormData });
    } else {
      setShowExpenseForm(false);
    }
  }, [commentFormData?.isException]);

  const saveComment = async () => {
    setIsLoading(true);
    try {
      if (isNewComment) {
        const commentToSave = commentFormData?.isException
          ? {
              ...commentFormData,
              statusId: commentFormData.statusId || PENDING_EXCEPTION_STATUS_ID,
              requestTypeId: commentFormData.requestTypeId || ZERO_GUID
            }
          : commentFormData;
        const response = await props.postAuthorizationComment(commentToSave, authorizationId);
        if (response.type === POST_AUTHORIZATION_COMMENTS_FAILURE) {
          props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
          return false;
        }
        savedDraft.current = commentFormData;
        const comments = await props.getAuthorizationComments(authorizationId);
        const newestException = comments?.response
          .map(r => r.info)
          .filter(c => c.isException === true)
          .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn))[0];

        if (newestException?.authorizationExceptionCommentId && onAfterCreate) {
          const exceptions = isAuthLineItem
            ? await props.getExceptionsByAuthorizationId(authorizationId)
            : await props.getExceptionsByClientId(clientId);

          let approved = isIdEqual(newestException.statusId, 'D71921DD-72F0-44E3-9F1D-ED9CF71CD285')
          setExceptionState(exceptions.response || []);
          onAfterCreate(newestException.authorizationExceptionCommentId, approved);
        }
        return true;
      } else {
        return await updateComment();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const isFormDirty = () => {
    return !_.isEqual(commentFormData, selectedComment);
  };

  const cancelComment = () => {
    if (halfView && isNewComment) {
      setCommentFormData(null);
      setSelectedComment(null);
    } else {
      setCommentFormData(selectedComment);
    }
  };

  const updateComment = async () => {
    setIsLoading(true);
    const commentToSave = commentFormData?.isException
      ? {
          ...commentFormData,
          statusId: commentFormData.statusId || PENDING_EXCEPTION_STATUS_ID,
          requestTypeId: commentFormData.requestTypeId || ZERO_GUID
        }
      : commentFormData;
    const resp = await props.updateAuthorizationComment(commentToSave, authorizationId, selectedComment.commentId);

    if (resp.type === UPDATE_AUTHORIZATION_COMMENTS_FAILURE) {
      props.showToast('Failed to update comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      setIsLoading(false);
      return false;
    } else {
      savedDraft.current = commentFormData;
      const comments = await props.getAuthorizationComments(authorizationId);
      props.showToast('Successfully updated comment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      const updated = comments.response.find(c => c.info.commentId === selectedComment.commentId);
      if (updated) {
        setSelectedComment(updated.info);
        setCommentFormData(updated.info);
        if (onUnsavedCommentResolved) onUnsavedCommentResolved(selectedComment.commentId);
      }
    }

    setIsLoading(false);
    return true;
  };

  const finishLeaving = async (shouldDeleteUnsaved = true) => {
    const action = pendingLeave?.action;
    if (shouldDeleteUnsaved && isUnsavedComment && selectedComment?.commentId) {
      setIsLoading(true);
      try {
        const response = await props.deleteAuthorizationComment(authorizationId, selectedComment.commentId);
        if (response.type === DELETE_AUTHORIZATION_COMMENTS_FAILURE) {
          props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
          return;
        }
        await props.getAuthorizationComments(authorizationId);
        if (onUnsavedCommentDeleted) onUnsavedCommentDeleted(selectedComment.commentId);
      } catch {
        props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
        return;
      } finally {
        setIsLoading(false);
      }
    }
    setPendingLeave(null);
    savedDraft.current = selectedComment || {};
    setCommentFormData(selectedComment);
    if (unblockNavigation.current) unblockNavigation.current();
    if (action) action();
  };

  const saveBeforeLeaving = async () => {
    setIsSavingBeforeLeave(true);
    try {
      if (await saveComment()) finishLeaving(false);
    } catch {
      props.showToast('Failed to save comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } finally {
      setIsLoading(false);
      setIsSavingBeforeLeave(false);
    }
  };


  const sendToClient = async () => {
    setIsLoading(true);
    // A copy, so a failed send can't leave the form marked as sent and carry that into a later Save to Pending
    const commentToSend = { ...commentFormData, isClientViewable: true, sentToClientDate: new Date() };
    const resp = await props.updateAuthorizationComment(commentToSend, authorizationId, selectedComment.commentId);

    if (resp.type === UPDATE_AUTHORIZATION_COMMENTS_FAILURE) {
      props.showToast('Failed to update comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      const comments = await props.getAuthorizationComments(authorizationId);
      props.showToast('Successfully updated comment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      const updated = comments.response.find(c => c.info.commentId === selectedComment.commentId);
      if (updated) {
        setSelectedComment(updated.info);
        setCommentFormData(updated.info);
        setIsExceptionSentToClient((updated.info.isClientViewable && updated.info.isException) || false);
        if (onUnsavedCommentResolved) onUnsavedCommentResolved(selectedComment.commentId);
      }
    }

    setIsLoading(false);
  };

  const handleServiceValueChange = value => {
    if (value === commentFormData?.serviceId) {
      return;
    }
    // Regarding options depend on the service, so the previous choice no longer applies
    setCommentFormData({ ...commentFormData, serviceId: value, regardingId: null });
  };

  const handleRegardingValueChange = value => {
    setCommentFormData({ ...commentFormData, regardingId: value });
  };

  const stripHtml = html => {
    if (!html) return '';

    if (typeof document === 'undefined') {
      let fallback = html.replace(/<\/(p|div|br|li|h[1-6])>/gi, '. ');
      fallback = fallback.replace(/<[^>]+>/g, ' ');
      fallback = fallback.replace(/\s+/g, ' ').trim();
      fallback = fallback.replace(/(\.\s*){2,}/g, '. ');
      return fallback;
    }
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    let text = tmp.textContent || tmp.innerText || '';

    text = text.replace(/<\/(p|div|br|ol|li|h[1-6])>/gi, '. ');

    text = text.replace(/\s+/g, ' ').trim();

    text = text.replace(/(\.\s*){2,}/g, '. ');

    return text;
  };

  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  const saveFiles = async filesToSave => {
    setIsUploading(true);

    try {
      // One at a time: each response replaces the comment's attachment list in the store, so concurrent
      // uploads could land out of order and leave the table missing files
      let failedCount = 0;
      for (const file of filesToSave) {
        let base64 = await convertToBase64(file);

        base64 = base64.split(',')[1]; // Remove the data:<contentType>;base64, part

        const response = await props.postAuthCommentsAttachment(
          {
            base64FileData: base64,
            fileName: file.name,
            contentType: file.type,
          },
          authorizationId,
          commentFormData.commentId,
        );
        if (response.type === POST_AUTH_COMMENTS_ATTACHMENT_FAILURE) failedCount += 1;
      }

      if (failedCount > 0) {
        props.showToast(
          `Failed to upload ${failedCount} of ${filesToSave.length} attachments, please try again later`,
          TOAST_MESSAGE_SEVERITY_ERROR,
        );
      } else {
        props.showToast('Successfully uploaded attachments', TOAST_MESSAGE_SEVERITY_SUCCESS);
      }
    } catch (error) {
      console.error('Error uploading files:', error);
      props.showToast('Failed to upload attachments, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } finally {
      setIsUploading(false);
    }
  };

  const updateFileDocumentShare = file => {
    setOpenDocumentShareDialog(true);
    setSelectedFileForDocumentShare(file);
    setWasAlreadyNotified(file.shouldNotify ? file.shouldNotify : false);
  };

  const updateFile = async () => {
    setIsUploading(true);
    const updateFileResp = await props.updateAuthCommentsAttachment(
      selectedFileForDocumentShare,
      authorizationId,
      commentFormData.commentId
    );
    if (updateFileResp.type === UPDATE_AUTH_COMMENTS_ATTACHMENT_FAILURE) {
      props.showToast('Failed to update attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      props.showToast('Successfully updated attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      setOpenDocumentShareDialog(false);
      setSelectedFileForDocumentShare(null);
      setWasAlreadyNotified(false);
    }
    setIsUploading(false);
  };

  const deleteFile = async file => {
    setIsUploading(true);
    const deleteFileResp = await props.deleteAuthCommentsAttachment(authorizationId, commentFormData.commentId, file.attachmentId);
    if (deleteFileResp.type === DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE) {
      props.showToast('Failed to delete attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      props.showToast('Successfully deleted attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
    }
    setIsUploading(false);
  };

  return (
    <Paper
      square
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '10px',
        backgroundColor: 'transparent',
        paddingLeft: '5px',
        paddingRight: '5px',
        border: 'none',
        borderLeft: '1px solid #ccc',
        boxShadow: 'none'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '90vh',
          pointerEvents: lockScreen ? 'none' : 'auto',
          opacity: lockScreen ? 0.5 : 1
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            {' '}
            {!isNewComment && (
              <>
                <Paper
                  square
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    padding: '16px',
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    boxShadow: 'none'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flex: 1,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '20px'
                    }}
                  >
                    {halfView && !isNewComment && (
                      <Box
                        textAlign="center"
                        sx={{
                          marginBottom: '16px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <IconButton
                          onClick={() => requestLeave(() => setSelectedComment(null))}
                          disabled={isReadOnly}
                          sx={{
                            backgroundColor: '#f5f5f5',
                            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
                            '&:hover': {
                              backgroundColor: '#e0e0e0'
                            },
                            color: '#43423a'
                          }}
                          aria-label="back"
                        >
                          <ArrowBack />
                        </IconButton>
                      </Box>
                    )}
                    {!isNewComment && (
                      <>
                        <Box textAlign="center">
                          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                            Added By
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            {internalUsersMapping.find((c) => c.id === commentFormData?.addedByUserId)?.title || ''}
                          </Typography>
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                            Created Party
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            {commentCreatedParties.find(s => s.id === commentFormData?.createdParty)?.title || ''}
                          </Typography>
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                            Modified By
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            {internalUsersMapping.find((c) => c.id === commentFormData?.modifiedByUserId)?.title || ''}
                          </Typography>
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                            Created Date
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            {formatDate(commentFormData?.addedOn)}
                          </Typography>
                        </Box>
                        { commentFormData?.sentToClientDate && (
                          <Box textAlign="center">
                            <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                              Sent To Client Date
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {formatDate(commentFormData?.sentToClientDate)}
                            </Typography>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                  {isEmailTemplate && false && (
                    <Button
                      color="primary"
                      variant="contained"
                      sx={{ height: '30px', marginRight: '20px' }}
                      onClick={() => setIsRichTextMode(prev => !prev)}
                    >
                      {isRichTextMode ? 'View HTML' : 'View Text'}
                    </Button>
                  )}
                  <Link
                    href="#"
                    sx={{
                      color: '#0000EE',
                      textDecoration: 'underline',
                      fontWeight: 500,
                      fontSize: '1rem',
                      paddingRight: '10px'
                    }}
                  >
                    Letters
                  </Link>
                </Paper>
              </>
            )}
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'serviceSelector'}>
                    Service
                  </InputLabel>
                  <Select
                    labelId={'serviceSelector'}
                    key={'serviceSelector'}
                    label={'Service'}
                    name={'service'}
                    required={true}
                    value={commentFormData?.serviceId || ''}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    disabled={isReadOnly || isExceptionSentToClient}
                    onChange={e => handleServiceValueChange(e.target.value)}
                  >
                    {serviceOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'regardingSelector'}>
                    Regarding
                  </InputLabel>
                  <Select
                    labelId={'regardingSelector'}
                    key={'regardingSelector'}
                    label={'Regarding'}
                    name={'regarding'}
                    required={true}
                    value={commentFormData?.regardingId || ''}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    disabled={isReadOnly || isExceptionSentToClient}
                    onChange={e => handleRegardingValueChange(e.target.value)}
                  >
                    {filteredRegardingOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              { !showExpenseForm && (
              <Box>
                <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key="clientViewable"
                    name="clientViewable"
                    labelPlacement="start"
                    label="Client Viewable"
                    control={
                      <Checkbox
                        checked={commentFormData?.isClientViewable || false}
                        disabled={isReadOnly || isExceptionSentToClient}
                        onChange={e => setCommentFormData({ ...commentFormData, isClientViewable: e.target.checked })}
                      />
                    }
                    sx={{ marginTop: '6px', minWidth: '90px' }}
                  />
                </FormControl>
              </Box>
              )}
              <Box>
                <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key="pinnedComment"
                    name="pinnedComment"
                    labelPlacement="start"
                    label="File Alert"
                    control={
                      <Checkbox
                        checked={commentFormData?.isPinned || false}
                        disabled={isReadOnly || isExceptionSentToClient}
                        onChange={e => setCommentFormData({ ...commentFormData, isPinned: e.target.checked })}
                      />
                    }
                    sx={{ marginTop: '6px', minWidth: '90px' }}
                  />
                </FormControl>
              </Box>
              <Box>
                <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key="isException"
                    name="isException"
                    labelPlacement="start"
                    label="Exception"
                    control={
                      <Checkbox
                        checked={commentFormData?.isException || false}
                        disabled={isReadOnly || isExceptionSentToClient}
                        onChange={e => {
                          const isException = e.target.checked;
                          setCommentFormData({
                            ...commentFormData,
                            isException,
                            statusId: isException ? PENDING_EXCEPTION_STATUS_ID : commentFormData?.statusId,
                            exceptionCodeId: isException
                              ? commentFormData?.exceptionCodeId || ZERO_GUID
                              : commentFormData?.exceptionCodeId
                          });
                        }}
                      />
                    }
                    sx={{ marginTop: '6px', minWidth: '90px' }}
                  />
                </FormControl>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <TextField
                  key={'subject'}
                  label={'Subject'}
                  name={'subject'}
                  required={true}
                  value={commentFormData?.subject || ''}
                  margin="dense"
                  multiline
                  variant="standard"
                  rows={1}
                  sx={{
                    width: '100%',
                    maxWidth: '600px',
                    minWidth: '200px'
                  }}
                  disabled={isReadOnly || isExceptionSentToClient}
                  onChange={e => setCommentFormData({ ...commentFormData, subject: e.target.value })}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  maxWidth: '600px',
                  minWidth: '200px'
                }}
              >
                {isEmailTemplate && isRichTextMode && isRichTextEditorEnabled ? (
                  <Box
                    sx={{
                      minHeight: 150,
                      '& .ql-container': {
                        minHeight: 150
                      }
                    }}
                  >
                    <EmailEditorQuill
                      key={commentFormData?.commentId || selectedComment?.commentId || 'new-template-comment'}
                      initialHtml={commentFormData?.comment || ''}
                      onHtmlChange={html =>
                        setCommentFormData(prev => ({
                          ...prev,
                          comment: html
                        }))
                      }
                    />
                  </Box>
                ) : (
                  <TextField
                    label={'Comment'}
                    name={'commentContent'}
                    required={true}
                    value={isEmailTemplate ? stripHtml(commentFormData?.comment) : commentFormData?.comment || ''}
                    margin="dense"
                    multiline
                    variant="standard"
                    rows={6}
                    fullWidth
                    sx={{
                      width: '100%',
                      maxWidth: '600px',
                      minWidth: '200px'
                    }}
                    disabled={isReadOnly || isExceptionSentToClient}
                    onChange={e =>
                      setCommentFormData(prev => ({
                        ...prev,
                        comment: e.target.value
                      }))
                    }
                  />
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            {isUploading && (
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
                <Typography variant="subtitle1">Updating Attachments...</Typography>
                <SpinnerComponent />
              </Box>
            )}

            {!isNewComment && (
              <AttachmentsUpload
                saveFiles={saveFiles}
                fileAttachments={
                  selectedComment && selectedComment.commentId && commentsAndNotesWithAttachments
                    ? commentsAndNotesWithAttachments.find(c => c.info.commentId === selectedComment.commentId)?.attachments
                    : []
                }
                isUploading={isUploading}
                updateFile={updateFileDocumentShare}
                deleteFile={deleteFile}
                webViewableText={'EE Web Viewable'}
                descriptionText={'EE Description'}
                isReadOnly={isReadOnly || isExceptionSentToClient}
              />
            )}
          </Grid>
          {showExpenseForm && (
            <ExceptionCommentComponent
              enumerations={enumerations ? enumerations.allEnums || enumerations : {}}
              commentFormData={commentFormData}
              clientContactOptions={
                clientContacts && Array.isArray(clientContacts)
                  ? clientContacts.map(c => ({
                    id: c.contact.clientContactId,
                    title: `${c.contact.firstName} ${c.contact.lastName}`,
                    isExceptionApprover: Boolean(c.contact.hasExceptionApprovalRouting),
                  }))
                  : []
              }
              savedExceptionApprovers={selectedComment?.exceptionApprovers || []}
              expenseCodes={expenseCodes}
              setCommentFormData={setCommentFormData}
              isExceptionSentToClient={isExceptionSentToClient}
            />
          )}
        </Grid>
        {!isReadOnly && !showExpenseForm && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '16px' }}>
            <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginLeft: '12px',
                marginTop: '8px',
                backgroundColor: '#868686',
                '&:hover': { backgroundColor: '#474747' }
              }}
              disabled={isCancelButtonDisabled}
              onClick={cancelComment}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginLeft: '12px',
                marginTop: '8px',
                backgroundColor: '#67A783',
                '&:hover': {
                  backgroundColor: '#53936F'
                },
                color: '#FFFFFF'
              }}
              disabled={isSubmitDisable}
              onClick={isNewComment ? saveComment : updateComment}
            >
              {'Save Comment'}
            </Button>
          </Box>
        )}
        {!isReadOnly && showExpenseForm && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '16px' }}>
            <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginLeft: '12px',
                marginTop: '8px',
                backgroundColor: '#868686',
                '&:hover': { backgroundColor: '#474747' }
              }}
              disabled={isCancelButtonDisabled}
              onClick={cancelComment}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginLeft: '12px',
                marginTop: '8px',
                backgroundColor: '#67A783',
                '&:hover': {
                  backgroundColor: '#53936F'
                },
                color: '#FFFFFF'
              }}
              disabled={isSubmitDisable || isExceptionSentToClient}
              onClick={isNewComment ? saveComment : updateComment}
            >
              {'Save to Pending'}
            </Button>
            {/* Sending needs the permission and required fields but no edit, so a comment saved to pending can be sent as is */}
            <Button
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginLeft: '12px',
                marginTop: '8px',
                backgroundColor: '#67A783',
                '&:hover': {
                  backgroundColor: '#53936F'
                },
                color: '#FFFFFF'
              }}
              disabled={!canSubmitExceptions || !checkRequiredValues() || isExceptionSentToClient}
              onClick={() => setIsSendToClientConfirmOpen(true)}
            >
              {'Save to Client'}
            </Button>
          </Box>
        )}
      </Box>

      <Dialog open={openDocumentShareDialog} onClose={() => setOpenDocumentShareDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Share Document with EE Via Portal</DialogTitle>
        <DialogContent>
          <Box>
            <Typography variant="body1">Document: {selectedFileForDocumentShare ? selectedFileForDocumentShare.fileName : ''}</Typography>
          </Box>
          <hr />
          <Box sx={{ marginTop: '16px', display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <Box>
              <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                <FormControlLabel
                  key="webViewable"
                  name="webViewable"
                  labelPlacement="start"
                  label="Web Viewable"
                  control={
                    <Checkbox
                      checked={selectedFileForDocumentShare ? selectedFileForDocumentShare.isWebViewable : false}
                      onChange={e => setSelectedFileForDocumentShare({ ...selectedFileForDocumentShare, isWebViewable: e.target.checked })}
                    />
                  }
                  sx={{ marginTop: '6px', minWidth: '90px' }}
                />
              </FormControl>
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                <FormControlLabel
                  key="shouldNotify"
                  name="shouldNotify"
                  labelPlacement="start"
                  label="Notify EE?"
                  disabled={wasAlreadyNotified}
                  control={
                    <Checkbox
                      checked={selectedFileForDocumentShare ? selectedFileForDocumentShare.shouldNotify : false}
                      onChange={e => setSelectedFileForDocumentShare({ ...selectedFileForDocumentShare, shouldNotify: e.target.checked })}
                    />
                  }
                  sx={{ marginTop: '6px', minWidth: '90px' }}
                />
              </FormControl>
            </Box>
          </Box>
          <hr />
          <Box sx={{ marginTop: '16px' }}>
            <Typography variant="body1">EE Primary Email: {defaultEmail ? defaultEmail : ''}</Typography>
          </Box>
          <hr />
          <Box sx={{ marginTop: '16px', minWidth: '400px' }}>
            <Box sx={{}}>
              <Box>
                <Typography variant="subtitle2">Description</Typography>
              </Box>
              <TextField
                key={'description'}
                label={''}
                name={'description'}
                required={false}
                disabled={wasAlreadyNotified}
                value={selectedFileForDocumentShare ? selectedFileForDocumentShare.description : ''}
                sx={{ maxWidth: '360px' }}
                type="text"
                multiline={true}
                rows={3}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth={true}
                onChange={e => setSelectedFileForDocumentShare({ ...selectedFileForDocumentShare, description: e.target.value })}
              />
            </Box>
          </Box>

          {wasAlreadyNotified && <Hint>You can no longer make changes to the description after the EE has been notified.</Hint>}
        </DialogContent>
        <DialogActions>
          {isUploading && <SpinnerComponent />}
          {!isUploading && !isNewComment && (
            <Box>
              <Button
                onClick={() => setOpenDocumentShareDialog(false)}
                color="secondary"
                variant="text"
                sx={{
                  color: '#868686',
                  '&:hover': {
                    color: '#474747',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Cancel
              </Button>
              <Button onClick={updateFile} color="primary">
                Confirm
              </Button>
            </Box>
          )}
          {!isUploading && isNewComment && (
            <Box>
              <Button
                onClick={() => setOpenDocumentShareDialog(false)}
                color="secondary"
                variant="text"
                sx={{
                  color: '#868686',
                  '&:hover': {
                    color: '#474747',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Cancel
              </Button>
              <Button onClick={saveComment} color="primary">
                Create Exception
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={Boolean(pendingLeave)} onClose={() => !isSavingBeforeLeave && setPendingLeave(null)}
        aria-labelledby="unsaved-comment-title">
        <DialogTitle id="unsaved-comment-title">{checkRequiredValues() ? 'Save changes?' : 'Unsaved changes'}</DialogTitle>
        <DialogContent>
          <Typography>This comment has unsaved changes.</Typography>
          {!checkRequiredValues() && (
            <Typography color="error">Please fill in all required fields before leaving.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          {/*<Button disabled={isSavingBeforeLeave} onClick={() => setPendingLeave(null)}>Cancel</Button>*/}
          <Button disabled={isSavingBeforeLeave} onClick={finishLeaving}>Discard</Button>
          {checkRequiredValues() ? (
            <Button variant="contained" disabled={isSavingBeforeLeave} onClick={saveBeforeLeaving}>
              Save
            </Button>
          ) : (
            <Button variant="contained" disabled={isSavingBeforeLeave} onClick={() => setPendingLeave(null)}>
              Continue Working
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isSendToClientConfirmOpen}
        title="Save to Client?"
        confirmLabel="Save to Client"
        onConfirm={() => {
          setIsSendToClientConfirmOpen(false);
          sendToClient();
        }}
        onCancel={() => setIsSendToClientConfirmOpen(false)}
      >
        <Typography>Once this exception is saved to the client, it can no longer be edited. Do you want to continue?</Typography>
      </ConfirmationDialog>
    </Paper>
  );
};

const mapStateToProps = state => ({});

export default compose(
  connect(mapStateToProps, {
    postAuthorizationComment,
    updateAuthorizationComment,
    showToast,
    postAuthCommentsAttachment,
    updateAuthCommentsAttachment,
    deleteAuthCommentsAttachment,
    deleteAuthorizationComment,
    getAuthorizationComments,
    getExceptionsByAuthorizationId,
    getExceptionsByClientId
  })
)(SelectedCommentAndNote);